export class AssessmentCategory {
  id: number;
  name: string;
  nameEn: string;
}
